var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefineMessageActiveButtonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGradient123",
    x1: 0.873,
    y1: 0.899,
    x2: 0.516,
    y2: 0.117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#540677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80ced"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,8.6a1.209,1.209,0,0,0-1.2-1.2H8.2a1.2,1.2,0,0,0,0,2.4h4.3l-4.74,4.74a1.2,1.2,0,1,0,1.7,1.7L14.2,11.5v4.3a1.2,1.2,0,1,0,2.4,0ZM12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "url(#purpleGradient123)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineMessageActiveButtonIcon);
export default __webpack_public_path__ + "static/media/refine-message-active-button-icon.e720a9a448ac3b40071c7263872c5d48.svg";
export { ForwardRef as ReactComponent };